// NA - Not Available

export const spiritBaseFareAncillaries = {
  brandId: 'NA',
  name: 'Basic Fare',
  tier: 1,
  brandAttributes: [
    {
      type: 'CHECKED_BAG',
      description: 'Checked bags',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'MEALS',
      description: 'Meal',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'REBOOKING',
      description: 'Changeable Ticket',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'WIFI',
      description: 'WiFi',
      inclusion: 'NOT_INCLUDED',
    },
    {
      type: 'CARRY_ON',
      description: 'Carry-on',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'SEATS',
      description: 'Seat Choice',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'REFUND',
      description: 'Cancellation',
      inclusion: 'CHARGEABLE',
    },
  ],
}
